module.exports = __webpack_public_path__ + "static/media/enhanced-grain-limedoak.5e89c26a.png";